import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/tenant-settings/semantic-governance")({
  beforeLoad: () => { throw redirect({ to: "/semantic-platform/concepts" }); },
});
